var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthersCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 121.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6F6F2;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,115.19l15.6-16.65c-8.1-10.05-12.45-23.7-12.45-39c0-33.45,20.85-58.2,54.6-58.2c14.85,0,27.3,4.95,36.45,13.2 L107.85,0l6.3,5.55l-14.1,15.15C108,30.9,112.5,44.25,112.5,59.55c0,33.3-21.15,58.2-54.75,58.2c-14.85,0-27.15-4.8-36.3-12.9 L6.3,121.05L0,115.19z M25.8,87.6l58.65-62.55c-6.45-6.6-15.3-10.5-26.7-10.5c-25.35,0-39,19.35-39,45 C18.75,70.35,21.15,80.1,25.8,87.6z M96.6,59.55c0-10.65-2.25-20.25-6.9-27.75L31.35,94.35c6.45,6.15,15.15,9.9,26.4,9.9 C83.1,104.25,96.6,85.05,96.6,59.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,3.75h88.8v13.5H174.6v98.1h-15.45v-98.1h-36.6V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,3.75h15.3V50.7h57.6V3.75h15.45v111.6h-15.45v-52.2h-57.6v52.2h-15.3V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6,3.75h79.35v13.5H342.9V51h57.9v12.75h-57.9v37.65h65.7v13.95h-81V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.89,3.75h52.2c19.95,0,33.45,12.3,33.45,30.75c0,13.65-5.55,23.25-20.4,27.9v0.45c12.6,3.75,16.2,11.25,17.25,27.3 c1.35,17.55,2.85,22.95,5.1,24.45v0.75h-16.35c-2.55-2.1-2.85-7.2-4.05-25.05c-1.05-15.75-7.65-21.45-22.2-21.45h-29.7v46.5h-15.3 V3.75z M436.19,56.55h31.95c15.15,0,22.65-7.65,22.65-19.8c0-13.05-6.15-19.8-21.9-19.8h-32.7V56.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.54,79.2h15.15c1.8,16.8,12.9,26.1,33.15,26.1c14.85,0,25.65-6.6,25.65-20.1c0-14.55-12.9-18-32.4-22.35 c-19.95-4.2-36.9-9.9-36.9-31.35c0-18.75,15.75-29.85,38.7-29.85c27.45,0,39.75,13.8,42.45,32.85h-14.85 c-1.95-13.5-11.7-20.85-27.45-20.85c-14.7,0-24.3,6-24.3,17.1c0,12.15,12.15,15.6,28.95,19.05c21.6,4.35,41.25,9.9,41.25,34.8 c0,21.15-17.4,33-41.55,33C532.19,117.6,516.74,100.5,515.54,79.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersCropped);
export default __webpack_public_path__ + "static/media/othersCropped.71947d79f890b4a54b2f51356fe9cc8d.svg";
export { ForwardRef as ReactComponent };